import React, {
    useState,
    useEffect,
    useRef,
    useCallback,
    createContext,
    useContext
  } from "react";
  import { createPortal } from "react-dom";
  import PropTypes from "prop-types";
  
  const WindowPortalContext = createContext(null);
  
  export const useWindowPortalContext = () => {
    return useContext(WindowPortalContext);
  };
  
  const RenderInWindow = (props) => {
    const [container, setContainer] = useState(null);
    const newWindow = useRef(null);
    const { title } = props;
    useEffect(() => {
      // Create container element on client-side
      setContainer(document.createElement("div"));
    }, []);
  
    const close = useCallback(() => {
      props.close(props.id);
    }, [props]);
  
    useEffect(() => {
      // When container is ready
      if (container) {
        // Create window
        newWindow.current = window.open(
          "",
          "",
          "width=600,height=400,left=200,top=200"
        );
        // Append container
        newWindow.current.focus();
        newWindow.current.document.body.appendChild(container);
        newWindow.current.document.title = title;
        // Save reference to window for cleanup
        const curWindow = newWindow.current;
        curWindow.addEventListener("beforeunload", close);
        // Return cleanup function
        return () => {
          curWindow.close();
          curWindow.removeEventListener("beforeunload", close);
        };
      }
    }, [container]);
  
    return (
      container &&
      createPortal(
        <WindowPortalContext.Provider
          value={{
            close
          }}
        >
          {props.children}
        </WindowPortalContext.Provider>,
        container
      )
    );
  };
  
  RenderInWindow.defaultProps = {
    title: PropTypes.string.isRequired,
    close: PropTypes.func.isRequired,
    id: PropTypes.number.isRequired
  };
  
  export default RenderInWindow;
  